module.exports = __webpack_public_path__ + "img/contact-banner.01fc4799.jpg";